const UrlApi = {
  // baseUrl: "https://api-dev.safrati.ai/admin",
  // baseUrlImage: "https://api-dev.safrati.ai/admin",
  // baseUrlclient: "https://api-dev.safrati.ai/user",
  // baseUrlImageClient: "https://api-dev.safrati.ai/user",
  baseUrl: process.env.REACT_APP_BASEURL,
  baseUrlImage: process.env.REACT_APP_BASEURLIMAGE,
  baseUrlclient: process.env.REACT_APP_BASEURL_CLIENT,
  baseUrlImageClient: process.env.REACT_APP_BASEURLIMAGE,
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
    dashboard: "admins/getDash",
  },
  users: {
    get: "users/get",
    add: "users/add",
    edit: "users/edit",
    delete: "users/delete",
    get_countries: "users/get_countries",
  },
  admin_logs: {
    get: "admins/get",
    edit: "admins/edit"
  },
  settings: {
    get: "settings/get",
    edit: "settings/update_settings",
  },
  reOrder: "re-order",
  copy: {
    create: "copy/create",
  },
  stats: {
    get: "home/stats",
    add: "home/add_stats",
    edit: "home/update_stats",
    delete: "home/delete_stats",
  },
  clients: {
    get: "clients/get",
    add: "clients/add",
    edit: "clients/edit",
    delete: "clients/delete",
    search: "clients/search",
  },
  services: {
    get: "services/get",
    add: "services/add",
    edit: "services/update",
    delete: "services/delete",
    dashboard: "services/getDash",
  },
  contact_us: {
    get: "contact_us/get",
    add: "contact_us/add",
    edit: "contact_us/update",
    delete: "contact_us/delete",
    dashboard: "contact_us/getDash",
  },
  quality: {
    get: "quality/get",
    add: "quality/add",
    edit: "quality/update",  // Note: Using 'update' to match your route
    delete: "quality/delete",
    dashboard: "quality/getDash",
  },
  our_team: {
    get: "our_team/get",
    add: "our_team/add",
    edit: "our_team/update",
    delete: "our_team/delete",
    dashboard: "our_team/getDash",
  },
  slideshow: {
    get: "slideshow/get",
    add: "slideshow/add",
    edit: "slideshow/update",
    delete: "slideshow/delete",
    dashboard: "slideshow/getDash",
  },
  companies: {
    get: "companies/get",
    add: "companies/add",
    edit: "companies/update",
    delete: "companies/delete",
  },
  projects: {
    get: "projects/get",
    add: "projects/add",
    edit: "projects/update",
    delete: "projects/delete",
    dashboard: "projects/getDash",
  },
  media: {
    get: "media/get",
    add: "media/add",
    edit: "media/edit",
    delete: "media/delete",
  },
};

export default UrlApi;
